import React, { Component } from 'react';
import PropTypes from 'prop-types';
import animateScrollTo from 'animated-scroll-to';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons';
// import { faPhoneAlt } from '@fortawesome/free-solid-svg-icons';
import exact from 'prop-types-exact';
import Select from 'react-select';
import { buildStateOptions, filterAffiliates } from '../helpers/affiliatesHelpers';
import Spinner from '../../../common/Spinner/Spinner';

class Affiliates extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedState: null,
            search: '',
            // already true after SSR; false when arriving via client-side navigation
            loaded: props.dataAffiliates.length > 0,
        };
    }

    componentDidMount() {
        animateScrollTo(0, { speed: 700 });

        Promise.resolve(this.props.getAffiliatesDataIfNeeded())
            .finally(() => this.setState({ loaded: true }));
    }

    // _mapBenefits = (dataBenefits) => dataBenefits.map((data) => (
    //     <div key={data.title} className="benefits">
    //         <FontAwesomeIcon icon={data.faIcon} className="icon fa-lg faBenefits" width="16" />
    //         <h3>
    //             {data.title}
    //         </h3>
    //         {/* eslint-disable-next-line react/no-danger */}
    //         <p dangerouslySetInnerHTML={{ __html: data.text }} />
    //     </div>
    // ))

    // eslint-disable-next-line class-methods-use-this
    _mapAffiliates = (dataAffiliates) => dataAffiliates.map((data) => {
        const [title, frequency] = data.filial.split(' - ');

        return (
            <div key={data.filial} className={`affiliate ${dataAffiliates?.length <= 3 ? 'tw-h-72' : ''}`}>
                <h3 className="tw-text-left tw-capitalize">
                    {title}
                </h3>
                <p className="frequency">
                    {this._formatFrequency(frequency)}
                </p>
                <p>
                    {data.enderecoRua}
                </p>
                <p>
                    {this._formatEnderecoCEP(data.enderecoCEP)}
                </p>
                <p>
                    <FontAwesomeIcon className="icon" icon={faEnvelope} width={20} />
                    {data.email || '--'}
                </p>
                <p className="tw-mb-0">
                    {/* <FontAwesomeIcon className="icon" icon={faPhoneAlt} width={20} /> */}

                    <svg className="tw-mr-1" width="20" height="19" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.6005 9.32161C8.87073 11.1416 4.45863 6.76925 6.19487 4.94201C7.2551 3.82617 6.05764 2.55143 5.39464 1.61325C4.15024 -0.145374 1.41949 2.28276 1.50182 3.82761C1.76399 8.69977 7.0341 14.4733 12.1374 13.9692C13.7335 13.8117 15.568 10.9286 13.7364 9.87484C12.8213 9.34761 11.5639 8.3076 10.6005 9.32089" stroke="#0053BF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>

                    {data.telefone || '--'}
                </p>
            </div>
        )
    })


    // Brazilian decimal separator is a comma, not a period (e.g. some records use "106.9" instead of "106,9")
    // eslint-disable-next-line class-methods-use-this
    _formatFrequency = (frequency) => (frequency ? frequency.replace('.', ',') : frequency)

    // normalizes inconsistent "CEP:"/"CEP"/"CEP –" prefixes and stray punctuation coming from the data source
    // eslint-disable-next-line class-methods-use-this
    _formatEnderecoCEP = (enderecoCEP) => {
        if (!enderecoCEP) {
            return enderecoCEP;
        }

        const location = enderecoCEP.split(' - ')[0];
        const cepMatch = enderecoCEP.match(/(\d[\d.]*-?\d{3})\s*$/);

        if (!location || !cepMatch) {
            return enderecoCEP;
        }

        const cepDigits = cepMatch[1].replace(/[.\s]/g, '');

        return `${location} - CEP: ${cepDigits}`;
    }

    handleSearchChange = (evt) => {
        this.setState({ search: evt.target.value });
    };

    handleStateChange = (selectedOption) => {
        this.setState({ selectedState: selectedOption ? selectedOption.value : null });
    };

    handleButtonClick = (state) => {
        this.setState((prev) => ({ selectedState: prev.selectedState === state ? null : state }));
    };

    render() {
        const optionsSelect = buildStateOptions(this.props.dataAffiliates);

        const customStyle = {
            container: (styles) => ({
                ...styles,
                width: '100%',
            }),
            control: (styles) => ({
                ...styles,
                borderColor: '#d1d5db',
                boxShadow: 'none',
                '&:hover': {
                    borderColor: '#d1d5db',
                },
            }),
            placeholder: () => ({
                color: '#000',
            }),
            input: () => ({
                color: 'transparent',
                caretColor: 'transparent',
            }),
            indicatorSeparator: () => ({
                color: 'transparent',
            }),
            dropdownIndicator: () => ({
                color: '#d1d5db',
                marginRight: 5,
                '&:hover': {
                    color: '#d1d5db',
                },
            }),
            option: (styles, { isSelected, isFocused }) => ({
                ...styles,
                height: '100%',
                width: '100%',
                backgroundColor: isSelected ? '#D0D5DD' : isFocused ? '#D0D5DD' : '#fff',
                transition: 'background-color 0.2s ease',
            }),
        }

        const filteredAffiliates = filterAffiliates(this.props.dataAffiliates, {
            state: this.state.selectedState,
            search: this.state.search,
        });

        const hasFilteredAffiliates = filteredAffiliates.length > 0;

        return (

            <section className="SectionAffiliates">
                <header>
                    <h1>Afiliadas</h1>
                    <p>A rádio Antena 1 está presente em sete estados e em mais de 550 municípios, além de uma filial em Roma (ITA)</p>
                </header>
                <div className="affiliatesSearch">
                    <input
                        type="search"
                        value={this.state.search}
                        onChange={this.handleSearchChange}
                        placeholder="Buscar por cidade, estado ou frequência"
                        aria-label="Buscar afiliada por cidade, estado ou frequência"
                        autoComplete="off"
                    />
                </div>
                <div className="containerItems">
                    <Select
                        instanceId="affiliates-state-select"
                        inputId="affiliates-state-select-input"
                        className="selectOptions"
                        options={optionsSelect}
                        onChange={this.handleStateChange}
                        value={optionsSelect.find((option) => option.value === this.state.selectedState) || null}
                        styles={customStyle}
                        placeholder="Selecione o estado"
                        isSearchable={false}
                        isClearable
                    />
                    <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-[100%_0%] lg:tw-grid-cols-[100%_0%] xl:tw-grid-cols-[25%_75%] tw-w-full">
                        <div className="filterCity">
                            {optionsSelect.map((option) => (
                                <button
                                    key={option.value}
                                    className={`buttonFilter ${this.state.selectedState === option.value ? 'active' : ''}`}
                                    type="button"
                                    aria-pressed={this.state.selectedState === option.value}
                                    onClick={() => this.handleButtonClick(option.value)}
                                >
                                    {option.label}
                                </button>
                            ))}
                        </div>

                        {!this.state.loaded ? (
                            <div className="tw-col-span-1 md:tw-col-span-2 lg:tw-col-span-2 xl:tw-col-span-1 tw-flex tw-items-center tw-justify-center">
                                <Spinner />
                            </div>
                        ) : hasFilteredAffiliates ? (
                            <div className="blockAffiliates tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-12 tw-justify-center xl:tw-pl-5">
                                {this._mapAffiliates(filteredAffiliates)}
                            </div>
                        ) : (
                            <div className="tw-flex tw-justify-center tw-top-2/4 tw-relative tw-text-center xl:tw-top-1/4">
                                <div className="noResults">
                                    {this.props.dataAffiliates.length === 0
                                        ? 'Não foi possível carregar as afiliadas. Tente novamente mais tarde.'
                                        : 'Nenhuma filial encontrada para a busca ou o estado selecionado.'}
                                </div>
                            </div>
                        )}
                    </div>

                </div>
            </section>
        );
    }
}

Affiliates.propTypes = exact({
    dataAffiliates: PropTypes.array,
    getAffiliatesDataIfNeeded: PropTypes.func.isRequired,
});

export default Affiliates;
